import { createFileRoute } from '@tanstack/react-router';
import { TriggerPersonaPage } from '@/pages/triggers/TriggerPersonaPage';
import { ALL_ARCHETYPE_SLUGS } from '@/constants/personas';
import type { ArchetypeSlug } from '@/types/persona';

interface Search {
  archetype?: ArchetypeSlug;
}

const VALID_ARCHETYPES = new Set<string>(ALL_ARCHETYPE_SLUGS);

export const Route = createFileRoute('/triggers/persona')({
  validateSearch: (s: Record<string, unknown>): Search =>
    typeof s.archetype === 'string' && VALID_ARCHETYPES.has(s.archetype)
      ? { archetype: s.archetype as ArchetypeSlug }
      : {},
  component: TriggerPersonaRoute,
});

function TriggerPersonaRoute() {
  const search = Route.useSearch();
  return search.archetype ? (
    <TriggerPersonaPage initialArchetype={search.archetype} />
  ) : (
    <TriggerPersonaPage />
  );
}
